import React, { useState } from 'react';

// Proje Sayfası'ndaki ikonlu maddeler/bölümler için küçük, gayrimenkul temalı
// FontAwesome ikon seçici. Serbest bir sınıf adı da girilebilir (ör. "fas fa-star").
export const IKON_LISTESI: string[] = [
    'fas fa-swimming-pool', 'fas fa-dumbbell', 'fas fa-shield-alt', 'fas fa-parking',
    'fas fa-wifi', 'fas fa-car', 'fas fa-tree', 'fas fa-child', 'fas fa-utensils',
    'fas fa-spa', 'fas fa-video', 'fas fa-elevator', 'fas fa-fire-extinguisher',
    'fas fa-water', 'fas fa-mountain', 'fas fa-couch', 'fas fa-bed', 'fas fa-bath',
    'fas fa-kitchen-set', 'fas fa-door-open', 'fas fa-warehouse', 'fas fa-building',
    'fas fa-sun', 'fas fa-snowflake', 'fas fa-plug', 'fas fa-dog', 'fas fa-basketball-ball',
    'fas fa-table-tennis', 'fas fa-book', 'fas fa-coffee', 'fas fa-store', 'fas fa-bus',
    'fas fa-school', 'fas fa-hospital', 'fas fa-shopping-cart', 'fas fa-subway',
    'fas fa-map-marker-alt', 'fas fa-check-circle', 'fas fa-star', 'fas fa-home',
];

interface Props {
    value: string | null | undefined;
    onChange: (ikon: string | null) => void;
}

const IkonSecici: React.FC<Props> = ({ value, onChange }) => {
    const [acik, setAcik] = useState(false);
    return (
        <div style={{ position: 'relative' }}>
            <button
                type="button"
                onClick={() => setAcik(o => !o)}
                style={{
                    width: 40, height: 40, borderRadius: 9, border: '1.5px solid #e2e8f0',
                    background: '#fff', color: value ? '#cd6906' : '#94a3b8',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    cursor: 'pointer', fontSize: 16,
                }}
                title="İkon seç"
            >
                <i className={value || 'fas fa-icons'}></i>
            </button>
            {acik && (
                <>
                    <div style={{ position: 'fixed', inset: 0, zIndex: 40 }} onClick={() => setAcik(false)} />
                    <div style={{
                        position: 'absolute', top: 46, left: 0, zIndex: 50,
                        background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12,
                        boxShadow: '0 12px 32px rgba(15,23,42,0.15)', padding: 12, width: 280,
                    }}>
                        <input
                            type="text"
                            placeholder="fas fa-... (serbest sınıf adı)"
                            defaultValue={value || ''}
                            onBlur={e => { if (e.target.value.trim()) onChange(e.target.value.trim()); }}
                            style={{ width: '100%', padding: '6px 10px', borderRadius: 7, border: '1.5px solid #e2e8f0', fontSize: 12, marginBottom: 10, boxSizing: 'border-box' }}
                        />
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 6, maxHeight: 180, overflowY: 'auto' }}>
                            {IKON_LISTESI.map(ik => (
                                <button
                                    key={ik}
                                    type="button"
                                    onClick={() => { onChange(ik); setAcik(false); }}
                                    title={ik}
                                    style={{
                                        width: 32, height: 32, borderRadius: 7,
                                        border: ik === value ? '1.5px solid #cd6906' : '1.5px solid transparent',
                                        background: ik === value ? '#fff7ed' : '#f8fafc',
                                        color: ik === value ? '#cd6906' : '#64748b',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 13,
                                    }}
                                >
                                    <i className={ik}></i>
                                </button>
                            ))}
                        </div>
                        {value && (
                            <button type="button" onClick={() => { onChange(null); setAcik(false); }}
                                style={{ marginTop: 8, fontSize: 11, color: '#dc2626', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                                İkonu kaldır
                            </button>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default IkonSecici;
